import { type FieldPolicy } from "@apollo/client";

export const dateTimeTypePolicy: FieldPolicy<Date, string> = {

  merge: (_, incoming: any) => {
    if (incoming === null || incoming === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return incoming;
    } else if (incoming instanceof Date) {
      return incoming;
    } else {
      return new Date(incoming as string);
    }
  },
};
